import apiClient from '@/services/axios'

export async function get(userId) {
  var response = await apiClient.get('/users/' + userId + '/checkOnlinePosCard')
  if (response) {
    return response.data
  }

  throw new Error('Unable to check card.')
}
